<template>
  <div>
    <section>
      <div class="inner inner--full row5">
        <img
          src="/images/general/incoming-feature.svg"
          :style="{ margin: 'auto', maxWidth: '100%' }"
          alt="Incoming Feature"
        />
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "IncomingFeature",
};
</script>
